<div class="annex-file-panel">
  <div class="annex-file-toolbar">
    <button
      mat-button
      type="button"
      [disabled]="!canZoomOut"
      [attr.aria-label]="'Annex.ZoomOut' | translate"
      [matTooltip]="'Annex.ZoomOut' | translate"
      (click)="zoomOut()"
    >
      <mat-icon>zoom_out</mat-icon>
    </button>
    <button
      mat-button
      type="button"
      [attr.aria-label]="'Annex.ZoomReset' | translate"
      [matTooltip]="'Annex.ZoomReset' | translate"
      (click)="zoomReset()"
    >
      <span class="zoom-btn-label">{{ zoomPercent }}%</span>
    </button>
    <button
      mat-button
      type="button"
      [disabled]="!canZoomIn"
      [attr.aria-label]="'Annex.ZoomIn' | translate"
      [matTooltip]="'Annex.ZoomIn' | translate"
      (click)="zoomIn()"
    >
      <mat-icon>zoom_in</mat-icon>
    </button>
  </div>
  <div
    class="pdf-viewer"
    (mousedown)="onPanStart($event)"
    (mousemove)="onPanMove($event)"
    (mouseup)="onPanEnd($event)"
    (mouseleave)="onPanEnd($event)"
  >
    <pdf-viewer
      [src]="pdfSrc"
      [zoom]="zoom"
      [zoom-scale]="'page-width'"
      [show-all]="true"
      [render-text]="true"
      [original-size]="false"
      [fit-to-page]="false"
      [autoresize]="true"
      [show-borders]="true"
    ></pdf-viewer>
  </div>
</div>
